import { TagInput } from './TagInput';

export default TagInput;
